import { useQuery } from "react-query"
import { useFilter } from "../../../filter/hook"
import dataAPI from "../../services/dataAPI"


export default function useCreditCore() {
    const{filter} = useFilter()
    const query = useQuery({
      queryKey: ['credit-consumer', filter],
      queryFn: () => dataAPI.getCreditSingleCounter(filter)
  })

  const lastCreditQuery = useQuery({
    queryKey: ['credit-consumer-last', filter.device_name],
    queryFn: () => dataAPI.getLastCreditSingleCounter(filter)
})



  return {

    filter, 
    lastCreditQuery: {
        data : lastCreditQuery.data,
        isLoading : lastCreditQuery.isLoading,
        isSuccess : lastCreditQuery.isSuccess,
        isError : lastCreditQuery.isError,
        error : lastCreditQuery.error,
        refetch : lastCreditQuery.refetch,
        isRefetching : lastCreditQuery.isRefetching
    },
    creditQuery : {
        data : query.data,
        isLoading : query.isLoading,
        isSuccess : query.isSuccess,
        isError : query.isError,
        error : query.error,
        refetch : query.refetch,
        isRefetching : query.isRefetching
    }
  }
}
